module.exports = __webpack_public_path__ + "static/media/Portrait-10243.307b5465.jpg";